import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { SectionTitle, EndpointDoc, InfoCard } from '../../../components/apidocs';
import { SLIP_ORDER_ENDPOINTS } from '../data/slipOrder';

const SlipOrderSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionTitle icon={faClipboardList} iconColor="bg-gradient-to-br from-violet-400 to-purple-500">
        Slip Order API
      </SectionTitle>
      <p className="text-gray-500 dark:text-slate-400 mb-5 text-sm">
        {t('apiDocs.slipOrderApiDesc')}
      </p>

      <InfoCard type="info" title={t('apiDocs.slipOrderWhenToUse')}>
        {t('apiDocs.slipOrderWhenToUseContent')}
      </InfoCard>

      <div className="bg-violet-50 dark:bg-violet-900/20 border border-violet-200/60 dark:border-violet-800 rounded-xl p-4 mb-6">
        <p className="text-violet-700 dark:text-violet-300 font-bold text-sm mb-2 flex items-center gap-2">
          <FontAwesomeIcon icon={faArrowRight} /> {t('apiDocs.slipOrderFlowTitle')}
        </p>
        <ol className="space-y-1 text-sm text-violet-700 dark:text-violet-300 list-decimal list-inside">
          <li>POST <code className="font-mono bg-violet-100 dark:bg-violet-900/40 px-1 rounded">/slip-orders</code> — {t('apiDocs.slipOrderFlow1Desc')}</li>
          <li>{t('apiDocs.slipOrderFlow2')}</li>
          <li>POST <code className="font-mono bg-violet-100 dark:bg-violet-900/40 px-1 rounded">/orders/:order_number/verify-slip</code> — {t('apiDocs.slipOrderFlow3Desc')}</li>
        </ol>
      </div>

      <InfoCard type="warning" title={t('apiDocs.slipOrderImportantTitle')}>
        {t('apiDocs.slipOrderImportantContent')}
      </InfoCard>

      <InfoCard type="warning" title="บัญชีรับโอนเปลี่ยนได้ทุก Order — ห้ามจำ/แคชบัญชีเดิม">
        บัญชีปลายทางใน <code className="font-mono text-xs bg-amber-50 dark:bg-amber-900/30 px-1 rounded">bank_info</code> ถูกกำหนดใหม่<strong>ตอนสร้าง Order แต่ละครั้ง</strong> และอาจเป็นคนละบัญชี/คนละธนาคารกับครั้งก่อนเสมอ
        — ต้องแสดงบัญชีจาก response ของ Order ปัจจุบันให้ลูกค้าเท่านั้น ห้ามแคชบัญชีเดิมหรือให้ลูกค้าโอนก่อนสร้าง Order เด็ดขาด (เงินจะเข้าผิดบัญชีและตรวจสลิปไม่ผ่าน)
        และต้องโอน<strong>ก่อนหมดเวลา</strong> (<code className="font-mono text-xs bg-amber-50 dark:bg-amber-900/30 px-1 rounded">expires_at</code>) เพราะบัญชีปลายทางถูกจองไว้ชั่วคราวต่อ Order
      </InfoCard>

      {/* GET /banks_slips — commented out: not recommended to select bank before creating order
           because order will be auto-assigned a bank; calling banks_slips in advance and transferring
           before order creation may result in transferring to the wrong account */}

      {SLIP_ORDER_ENDPOINTS(t).map((spec, idx) => <EndpointDoc key={idx} {...spec} />)}
    </div>
  );
};

export default SlipOrderSection;
